import React from 'react';
import { motion } from 'framer-motion';

export default function AboutSection({ brand, processSteps, onShippingWhatsApp, onViewPups }) {
  return (
    <section className="about about-extended" id="about">
      <motion.h2 initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
        About {brand}
      </motion.h2>

      <div className="process-inner">
        <motion.div
          className="process-head"
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h3>WE ENSURE A SMOOTH TRANSITION.</h3>
          <p>
            At {brand}, we strive to provide a comprehensive package to ensure a smooth transition for your new furry
            friend into their forever home. Each puppy comes with up-to-date immunization records, detailing all
            vaccinations and preventive care they&apos;ve received. This information is crucial for maintaining their
            health and well-being.
          </p>
          <p>
            To add a touch of comfort and joy, we also include a plush toy with each puppy. This not only serves as a
            source of entertainment but also provides a familiar scent from their earlier days with us, helping them
            settle into their new environment more easily. We believe in not just delivering a pet but offering a
            holistic experience that sets the foundation for a happy and healthy life together. If you have any specific
            preferences or questions about our delivery process, feel free to let us know!
          </p>
        </motion.div>

        <div className="process-grid" aria-label="Our process">
          {processSteps.map((step, idx) => (
            <motion.div
              key={step.title}
              className="process-card"
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.55, delay: idx * 0.05 }}
              whileHover={{ y: -6 }}
            >
              <button
                type="button"
                className="process-icon"
                onClick={onShippingWhatsApp}
                aria-label="Message us on WhatsApp about shipping"
                title="Tap to ask about shipping on WhatsApp"
              >
                <motion.img
                  src={step.icon}
                  alt=""
                  aria-hidden="true"
                  animate={{ y: [0, -6, 0] }}
                  transition={{ duration: 3.2 + idx * 0.25, repeat: Infinity, ease: 'easeInOut' }}
                />
              </button>
              <h4>{step.title}</h4>
              <p>{step.body}</p>
            </motion.div>
          ))}
        </div>

        <div className="process-cta">
          <button className="process-cta-btn" onClick={onViewPups} type="button">
            SHOW AVAILABLE PUPS
          </button>
        </div>
      </div>
    </section>
  );
}

